
import "./index.css";

function FillInTheBlankWidgetContent(props) {
  function onChange(e) {
    const updatedArr = [...props.widgets];
    updatedArr[props.position - 1].question = e.target.value;
    props.setWidgets(updatedArr);
  }
  
  return (
    <div className="FillInTheBlankWidget">
      <textarea
        value={props.question || ""}
        onChange={onChange}
      />
      <div className="FillInTheBlankWidgetInfo">
        <span style={{ color: "#FC5A5A" }}>*</span>
        <span>two dash __ will be one blank space for answer</span>
      </div>
    </div>
  )
}

export default FillInTheBlankWidgetContent;
